export const PENDING_TASK_REMINDER = "pending-task-reminder";
export const BI_WEEKLY_PRODUCT_UPDATE = "bi-weekly-product-update";
export const NEW_PERK_LAUNCHED = "new-perk-launched";
export const NEW_TASK_LAUNCHED = "new-task-launched";
export const NEW_CHAT_NOTIFICATION = "new-chat-notification";
